import React, { Component } from 'react'
import VehicleDetailSection from './vehicle/vehicleDetailSection'
import CreditApplicationSection from './credit/creditApplicationSection'
import ProfileDetailSection from './profile/profileDetailSection'
import RefiSummary from './refiSummary'
import Breadcrumb from '../../components/Breadcrumb'
import { selectCurrentRefiUser } from '../../reducers'
import { User } from '../../core/types'
import CoverageDetailsSections from './coverages/CoverageDetailsSections'
import RefiAppStatusCheck from './RefiAppStatusCheck'
import QuoteHomeProtectionBtn from '../users/QuoteHomeProtectionBtn'

import { connect } from 'react-redux'
import {
  resetCurrentApplication,
  prefillUserInRefiApp,
  prefillVehicleValuesInRefiApp,
  markFreshDealInRefiApp,
} from './refiActions'
import { fetchBusinessConfig } from '../common/config'
import { parseQuery } from '../../helpers/queryHelper'

/**
 * Props injected by redux via mapDispatchToProps
 */
interface RefiAppProps {
  resetCurrentApplication?: () => void
  fetchBusinessConfig?: () => void
  prefillUserInRefiApp?: (userId: string) => void
  prefillVehicleValuesInRefiApp?: (values: Record<string, any>) => void
  markFreshDealInRefiApp?: () => void
  location?: { search: string }
}

const levels = [
  { label: 'Index', path: '/' },
  { label: 'People', path: '/users' },
  { label: 'New Applicant', path: '/refiapp' },
]

export class RefiApp extends Component<RefiAppProps & { user: User }> {
  static displayName = 'New Applicant'

  componentDidMount() {
    this.props.fetchBusinessConfig?.()
    this.props.resetCurrentApplication?.()
    const query = parseQuery(this.props.location?.search || '')
    if (query.userId && this.props.prefillUserInRefiApp) {
      this.props.prefillUserInRefiApp(String(query.userId))
    }
    // The CallTools deals modal's New Deal button hands the synced vehicle over
    // as values, never as an id, so the Vehicle step opens prefilled but bound
    // to no vehicle row (see CallToolsDealsModal#newDealSearch).
    if (this.props.prefillVehicleValuesInRefiApp) {
      this.props.prefillVehicleValuesInRefiApp(query)
    }
    // New Deal and Add a Vehicle both send fresh=1: start a deal, never resume
    // the customer's existing one on this vehicle.
    if (query.fresh && this.props.markFreshDealInRefiApp) {
      this.props.markFreshDealInRefiApp()
    }
  }

  render() {
    return (
      <>
        <RefiAppStatusCheck />
        <div
          className="refi-app__header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Breadcrumb
            levels={levels.map((l) =>
              l.path === '/refiapp' && this.props.user?.firstName
                ? {
                    ...l,
                    label: `${this.props.user.firstName} ${this.props.user.lastName}`,
                    path: `/users/${this.props.user.id}`,
                  }
                : l
            )}
          />
          <div
            className="refi-app__header-actions"
            data-testid="refi-app-header-actions"
            style={{ marginRight: '2vw' }}
          >
            <QuoteHomeProtectionBtn
              user={this.props.user}
              variant="icon"
              disabledTooltip="Save applicant first to quote home protection"
            />
          </div>
        </div>
        <div className="refi-app">
          <div className="refi-app__column">
            <VehicleDetailSection />
            <ProfileDetailSection />
            {false && <CreditApplicationSection />}
            <CoverageDetailsSections />
          </div>
          <div className="refi-app__column">
            <RefiSummary />
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  user: selectCurrentRefiUser(state),
})

export default connect(mapStateToProps, {
  resetCurrentApplication,
  fetchBusinessConfig,
  prefillUserInRefiApp,
  prefillVehicleValuesInRefiApp,
  markFreshDealInRefiApp,
})(RefiApp)
